<template>
  <v-dialog v-model="dialog" max-width="95%" width="max-content">
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator">
        <v-img
          :contain="minContain"
          class="minImg"
          :max-height="maxHeight"
          :min-height="minHeight"
          :min-width="minWidth"
          :max-width="maxWidth || '100%'"
          v-bind="attrs"
          v-on="on"
          :src="
            src
              ? typeof src === 'string'
                ? src.includes('https:')
                  ? src
                  : apiDomain + '/min/' + src
                : onShowFile(src)
              : minImg
          "
          alt=""
          @click.stop="!editing ? (dialog = true) : (dialog = false)"
          :position="position"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                :color="avatar ? '#ffffff' : '#277faf'"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </slot>
    </template>
    <template v-slot:default>
      <transition :duration="150">
        <div v-if="dialog" class="body" :class="{ edit: editing }">
          <div class="body_close" @click="closeModal">
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23 3.28555L19.7145 0L11.5 8.21445L3.28555 0L0 3.28555L8.21445 11.5L0 19.7145L3.28555 23L11.5 14.7855L19.7145 23L23 19.7145L14.7855 11.5L23 3.28555Z"
                fill="#277FAF"
              />
            </svg>
          </div>
          <div class="body_grid" :class="{ gallery: items && items.length > 1 }">
            <button
              v-if="items && items.length > 1"
              class="customBtn prev"
              @click="clickPrev()"
              :disabled="items && items.length == 1"
            >
              <svg
                width="62"
                height="54"
                viewBox="0 0 62 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M61.4532 26.8923C61.4532 27.898 61.0537 28.8626 60.3425 29.5738C59.6313 30.285 58.6667 30.6846 57.6609 30.6846H13.7232L30.0074 46.9611C30.36 47.3137 30.6397 47.7323 30.8305 48.193C31.0214 48.6537 31.1196 49.1475 31.1196 49.6461C31.1196 50.1447 31.0214 50.6385 30.8305 51.0992C30.6397 51.5599 30.36 51.9785 30.0074 52.331C29.6548 52.6836 29.2362 52.9633 28.7756 53.1542C28.3149 53.345 27.8211 53.4432 27.3225 53.4432C26.8238 53.4432 26.3301 53.345 25.8694 53.1542C25.4087 52.9633 24.9901 52.6836 24.6375 52.331L1.88366 29.5772C1.5305 29.2249 1.2503 28.8064 1.05912 28.3457C0.867939 27.885 0.769531 27.3911 0.769531 26.8923C0.769531 26.3934 0.867939 25.8995 1.05912 25.4388C1.2503 24.9781 1.5305 24.5596 1.88366 24.2073L24.6375 1.45345C25.3496 0.74136 26.3154 0.341309 27.3225 0.341309C28.3295 0.341309 29.2953 0.74136 30.0074 1.45345C30.7195 2.16555 31.1196 3.13135 31.1196 4.13841C31.1196 5.14546 30.7195 6.11127 30.0074 6.82336L13.7232 23.0999H57.6609C58.6667 23.0999 59.6313 23.4995 60.3425 24.2107C61.0537 24.9219 61.4532 25.8865 61.4532 26.8923Z"
                  fill="white"
                />
              </svg>
            </button>
            <div class="body_img" :class="{ scheme: type == 'scheme' }">
              <v-progress-circular
                class="progress"
                indeterminate
                color="#277faf"
              ></v-progress-circular>
              <img
                :src="
                  items && items.length > 1
                    ? items[activeImageIndex].includes('https:')
                      ? items[activeImageIndex]
                      : apiDomain +
                        '/' +
                        (type == 'scheme' ? items[activeImageIndex].url : items[activeImageIndex])
                    : src
                    ? typeof src === 'string'
                      ? src.includes('https:')
                        ? src
                        : apiDomain + '/' + src
                      : onShowFile(src)
                    : maxImg
                "
                alt=""
              />
            </div>
            <button
              v-if="items && items.length > 1"
              class="customBtn next"
              @click="clickNext()"
              :disabled="items && items.length == 1"
            >
              <svg
                width="62"
                height="54"
                viewBox="0 0 62 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.546761 26.8923C0.546761 27.898 0.946304 28.8626 1.6575 29.5738C2.36869 30.285 3.33329 30.6846 4.33907 30.6846H48.2768L31.9926 46.9611C31.64 47.3137 31.3603 47.7323 31.1695 48.193C30.9786 48.6537 30.8804 49.1475 30.8804 49.6461C30.8804 50.1447 30.9786 50.6385 31.1695 51.0992C31.3603 51.5599 31.64 51.9785 31.9926 52.331C32.3452 52.6836 32.7638 52.9633 33.2244 53.1542C33.6851 53.345 34.1789 53.4432 34.6775 53.4432C35.1762 53.4432 35.6699 53.345 36.1306 53.1542C36.5913 52.9633 37.0099 52.6836 37.3625 52.331L60.1163 29.5772C60.4695 29.2249 60.7497 28.8064 60.9409 28.3457C61.1321 27.885 61.2305 27.3911 61.2305 26.8923C61.2305 26.3934 61.1321 25.8995 60.9409 25.4388C60.7497 24.9781 60.4695 24.5596 60.1163 24.2073L37.3625 1.45345C36.6504 0.74136 35.6846 0.341309 34.6775 0.341309C33.6705 0.341309 32.7047 0.74136 31.9926 1.45345C31.2805 2.16555 30.8804 3.13135 30.8804 4.13841C30.8804 5.14546 31.2805 6.11127 31.9926 6.82336L48.2768 23.0999H4.33907C3.33329 23.0999 2.36869 23.4995 1.6575 24.2107C0.946304 24.9219 0.546761 25.8865 0.546761 26.8923Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
          <div class="buttons">
            <a
              class="body_save f16"
              :href="
                items && items.length > 1
                  ? items[activeImageIndex].includes('https:')
                    ? items[activeImageIndex]
                    : apiDomain +
                      '/' +
                      (type == 'scheme' ? items[activeImageIndex].url : items[activeImageIndex])
                  : src
                  ? typeof src === 'string'
                    ? src.includes('https:')
                      ? src
                      : apiDomain + '/' + src
                    : onShowFile(src)
                  : maxImg
              "
              download
              target="_blank"
            >
              <svg
                width="24"
                height="17"
                viewBox="0 0 24 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 0C10.0204 0.00620777 8.10822 0.720203 6.609 2.013C5.46 3.003 4.6275 4.293 4.413 5.5875C1.899 6.1425 0 8.3325 0 10.977C0 14.049 2.562 16.5 5.6715 16.5H19.0305C21.753 16.5 24 14.355 24 11.6595C24 9.2055 22.137 7.206 19.749 6.8685C19.3845 2.9985 16.035 0 12 0ZM15.531 10.281L12.531 13.281C12.4613 13.3508 12.3786 13.4063 12.2874 13.4441C12.1963 13.4819 12.0987 13.5013 12 13.5013C11.9013 13.5013 11.8037 13.4819 11.7125 13.4441C11.6214 13.4063 11.5387 13.3508 11.469 13.281L8.469 10.281C8.39927 10.2113 8.34395 10.1285 8.30622 10.0374C8.26848 9.94627 8.24905 9.84862 8.24905 9.75C8.24905 9.65138 8.26848 9.55373 8.30622 9.46262C8.34395 9.37152 8.39927 9.28873 8.469 9.219C8.60983 9.07817 8.80084 8.99905 9 8.99905C9.09862 8.99905 9.19627 9.01848 9.28738 9.05622C9.37848 9.09395 9.46127 9.14927 9.531 9.219L11.25 10.9395V5.25C11.25 5.05109 11.329 4.86032 11.4697 4.71967C11.6103 4.57902 11.8011 4.5 12 4.5C12.1989 4.5 12.3897 4.57902 12.5303 4.71967C12.671 4.86032 12.75 5.05109 12.75 5.25V10.9395L14.469 9.219C14.6098 9.07817 14.8008 8.99905 15 8.99905C15.1992 8.99905 15.3902 9.07817 15.531 9.219C15.6718 9.35983 15.7509 9.55084 15.7509 9.75C15.7509 9.94916 15.6718 10.1402 15.531 10.281Z"
                  fill="#277FAF"
                />
              </svg>
              {{ localStorage.translations.pages.common.buttons.sohranit }}
            </a>
            <slot name="button"></slot>
          </div>
        </div>
      </transition>
    </template>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ImageFullModal',
  props: [
    'minImg',
    'maxImg',
    'editing',
    'onOn',
    'attrsAttrs',
    'avatar',
    'maxHeight',
    'minHeight',
    'minContain',
    'maxWidth',
    'minWidth',
    'type',
    'items',
    'itemActive',
    'position',
    'src',
  ],
  components: {},
  data() {
    return {
      dialog: false,
      element: null,
      dialogHeight: null,
      activeImageIndex: null,
    }
  },
  methods: {
    closeModal() {
      this.dialog = false
      this.activeImageIndex = this.itemActive
    },
    clickPrev() {
      if (this.activeImageIndex === 0) {
        this.activeImageIndex = this.items.length - 1
      } else {
        this.activeImageIndex = this.activeImageIndex - 1
      }
    },
    clickNext() {
      if (this.activeImageIndex === this.items.length - 1) {
        this.activeImageIndex = 0
      } else {
        this.activeImageIndex = this.activeImageIndex + 1
      }
    },
    onShowFile(file) {
      return URL.createObjectURL(file)
    },
  },
  watch: {},
  computed: {
    ...mapGetters(['apiDomain']),
    test() {
      return this.$refs.test && this.$refs.clientWidth
    },
  },
  mounted() {
    this.activeImageIndex = this.itemActive
  },
}
</script>

<style lang="scss" scoped>
.minImg {
  position: relative;
  z-index: 2;
  // width: 100%;
  height: auto;
  cursor: pointer;
  &::before {
    content: url('data:image/svg+xml; utf8, <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 9.10894C11.9109 9.10894 12.6493 8.38962 12.6493 7.50229C12.6493 6.61496 11.9109 5.89563 11 5.89563C10.0891 5.89563 9.35066 6.61496 9.35066 7.50229C9.35066 8.38962 10.0891 9.10894 11 9.10894Z" fill="white"/><path d="M21.8527 6.96673C21.149 5.77781 17.2785 -0.188229 10.7031 0.00456941C4.62253 0.154524 1.10393 5.36008 0.147314 6.96673C0.0508068 7.12956 0 7.31427 0 7.50229C0 7.6903 0.0508068 7.87501 0.147314 8.03784C0.840038 9.20534 4.54557 15 11.022 15H11.2969C17.3775 14.85 20.9071 9.64449 21.8527 8.03784C21.9492 7.87501 22 7.6903 22 7.50229C22 7.31427 21.9492 7.12956 21.8527 6.96673ZM11 11.2511C10.2388 11.2511 9.49478 11.0313 8.8619 10.6193C8.22903 10.2074 7.73576 9.62192 7.44448 8.93691C7.15319 8.2519 7.07698 7.49813 7.22548 6.77092C7.37397 6.04371 7.7405 5.37573 8.27872 4.85144C8.81694 4.32716 9.50267 3.97011 10.2492 3.82546C10.9957 3.68081 11.7695 3.75505 12.4727 4.03879C13.176 4.32253 13.777 4.80303 14.1999 5.41953C14.6228 6.03603 14.8485 6.76083 14.8485 7.50229C14.8485 8.49654 14.443 9.45008 13.7213 10.1531C12.9996 10.8562 12.0207 11.2511 11 11.2511Z" fill="white"/></svg>');
    transition: 0.3s;
    background: #16558fcc;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  &:hover {
    &::before {
      cursor: pointer;
      opacity: 1;
    }
  }
  :deep().v-responsive__content {
    width: 100% !important;
  }
}
:deep().body {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &_close {
    padding: 10px;
    cursor: pointer;
    width: max-content;
    background: #e1e1e1;
    border-radius: 5px;
    transition: 0.3s;
    margin-bottom: 20px;
    &:hover {
      svg {
        path {
          fill: #f44336;
        }
      }
    }
  }
  &_grid {
    width: 100%;
    display: flex;
    column-gap: 20px;
    align-items: center;
    .prev,
    .next {
      //display: none;
      // position: absolute;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      padding: 30px !important;
      height: max-content;
      opacity: 1;
      user-select: none;
      svg {
        margin: auto;
      }
      @media screen and (max-width: 999px) {
        padding: 5px !important;
      }
    }
    .prev {
      left: 0;
    }
    .next {
      right: 0;
    }
    &.gallery {
      .prev,
      .nest {
        display: block;
      }
    }
  }
  &_img {
    line-height: 0 !important;
    width: 100%;
    height: auto;
    position: relative;
    // max-width: 50vw;
    // .v-responsive__content {
    //     width: 100% !important;
    // }
    img {
      // max-width: ;
      width: 100%;
      height: auto;
      max-height: 75vh;
    }
    &.scheme {
      background: #ffffff;
    }
    .progress {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
    }
  }
  .buttons {
    margin-top: 20px;
    display: flex;
    gap: 20px;
    align-items: center;
  }
  &_save {
    display: flex;
    align-items: center;
    column-gap: 16px;
    padding: 12px 24px;
    width: max-content;
    background: #ffffff;
    height: max-content;
    color: #277faf;
    border-radius: 28px;
    transition: 0.3s;
    text-decoration: none;
    &:hover {
      background: #277faf;
      color: #ffffff;
      svg {
        path {
          fill: #ffffff;
        }
      }
    }
  }
}
</style>
